import * as React from 'react';
import { Progress, Row, Col, Label, Spinner } from 'reactstrap';
import { selectDocumentStatus } from '../../redux/DocumentsSlice';
import { useAppSelector } from '../../hooks';

const DisplayNotificationUpdates = (props: any) => {

    const documentStatusSelector = useAppSelector(selectDocumentStatus);
 
    return (
        <React.Fragment>
            { documentStatusSelector.isEnabled ?
                (
                    <div>
                        <Row>
                            <Col md="6">
                                <Progress animated
                                    value={documentStatusSelector.progress}
                                    color={documentStatusSelector.status} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md="2">
                                {
                                    documentStatusSelector.status == "info" ?
                                        <div><Spinner color="primary" /></div> :
                                        <div></div>
                                }
                            </Col>
                            <Col md="4">
                                <Label>{documentStatusSelector.message}</Label>
                            </Col>
                        </Row>
                    </div>
                ):
                    (<div></div>)
            } 
        </React.Fragment>
    );

}


export default DisplayNotificationUpdates;